import React from "react";

const GraphLegends = ({ color, label }) => {
  return (
    <div className="flex-row align-center justify-start g-05">
      <div
        style={{
          width: "0.7rem",
          height: "0.7rem",
          borderRadius: "50%",
          background: color,
        }}
      ></div>
      <label htmlFor="title" className="t-12 poppins weight-500">
        {label}
      </label>
    </div>
  );
};

export default GraphLegends;
